export default __webpack_public_path__ + "static/media/PINK.76002729.svg";